export default {
    "welcome": {
        "title": "Bienvenido a ProcrastiQ",
        "subtitle": "Tu compa?ero de productividad",
        "modal": {
            "title": "Bienvenido a ProcrastiQ",
            "headline": "Pausas inteligentes para tu cerebro",
            "subheading": "Bocadillos para el cerebro, datos y momentos de atenci?n plena que convierten minutos libres en algo significativo.",
            "text": "Procrastiq es donde la procrastinaci?n se vuelve algo significativo. En lugar de desplazarte sin fin por las redes sociales, descubrir?s r?pidos bocadillos cerebrales dise?ados para entretener, estimular tu mente y tal vez incluso ense?arte algo nuevo.\n\nEsto no se trata de productividad a toda costa. Todos necesitan un momento para pausar, recargar energ?as y alejarse del trabajo. Procrastiq te ayuda a convertir esos peque?os descansos en algo positivo, lleno de curiosidad, disfrute y entrenamiento diario del cerebro. Peque?os desaf?os. Gran progreso.",
            "cta": "Vamos"
        }
    },
    "login": {
        "title": "Iniciar sesi?n",
        "email": "Correo electr?nico",
        "password": "Contrase?a",
        "submit": "Iniciar sesi?n",
        "cancel": "Cancelar",
        "success": "Inicio de sesi?n exitoso",
        "lead": "Bienvenido de nuevo: retoma tu racha y asciende en las ligas."
    },
    "logout": "Cerrar sesi?n",
    "logo": {
        "title": "ProcrastiQ",
        "slogan": "Pausas inteligentes para tu cerebro"
    },
    "register": {
        "title": "Registrarse",
        "name": "Nombre",
        "email": "Correo electr?nico",
        "password": "Contrase?a",
        "submit": "Crear cuenta",
        "cancel": "Cancelar",
        "success": "Registro exitoso",
        "country": "Pa?s",
        "lead": "Crea una cuenta para ganar XP, desbloquear rangos y unirte a ligas semanales."
    },
    "social": {
        "divider": "O continuar con",
        "signInWith": "Iniciar sesi?n con {{provider}}",
        "continueWith": "Continuar con {{provider}}",
        "failed": "El inicio de sesi?n social fall?",
        "popup_blocked": "Se bloque? la ventana emergente. Por favor, permite ventanas emergentes y vuelve a intentarlo.",
        "cancelled": "El inicio de sesi?n fue cancelado."
    },
    "common": {
        "cancel": "Cancelar",
        "saving": "Guardando...",
        "unknown_error": "Error desconocido",
        "select_country": "Seleccionar pa?s",
        "select_option": "Selecciona una opci?n",
        "country": "Pa?s"
    },
    "language": {
        "page_language": "Idioma de la p?gina",
        "switch_to": "Cambiar a {{language}}"
    },
    "cookies": {
        "title": "Cookies",
        "message": "Usamos cookies de anal?tica (Google Analytics) para mejorar Procrastiq.",
        "privacy_link": "Pol?tica de privacidad",
        "accept": "Aceptar",
        "reject": "Rechazar"
    },
    "footer": {
        "columns": {
            "about": {
                "title": "Sobre nosotros",
                "mission": "Misi?n",
                "progression": "XP, niveles y ligas",
                "creator_progression": "XP y rangos de creadores",
                "contact": "Cont?ctanos"
            },
            "leaderboards": {
                "title": "Clasificaciones",
                "players": "Miembros",
                "creators": "Colaboradores"
            },
            "legal": {
                "title": "Privacidad y T?rminos",
                "community": "Normas de la comunidad",
                "terms": "T?rminos de servicio",
                "privacy": "Pol?tica de privacidad"
            },
            "social": {
                "title": "Social",
                "facebook": "Facebook",
                "instagram": "Instagram"
            }
        }
    },
    "pages": {
        "mission": {
            "title": "Misi?n",
            "content": "ProcrastiQ convierte los peque?os descansos en momentos significativos: refrigerios mentales, acertijos y pausas conscientes que entretienen y estimulan tu mente.\n\nCreemos que la procrastinaci?n no tiene que ser tiempo perdido. Todos merecen un momento para recargar energ?as, y ayudamos a que esos momentos sean positivos, curiosos y divertidos."
        },
        "contact": {
            "title": "Cont?ctanos",
            "content": "?Tienes una pregunta, una idea de mejora o te has encontrado con algo que no funciona como deber?a? Escr?benos: cada comentario nos ayuda a seguir mejorando Procrastiq.\n\nPuedes escribirnos a:\n\nhello@procrastiq.com\n\nTambi?n nos encantar? leer tus propuestas de nuevo contenido, funciones o temas que te gustar?a ver en Procrastiq."
        },
        "community": {
            "title": "Directrices de la comunidad",
            "content": "ProcrastiQ es un espacio acogedor para mentes curiosas. S? respetuoso, amable y constructivo en tus interacciones.\n\nNo publiques contenido da?ino, abusivo o spam. Reporta cualquier cosa que no pertenezca. Juntos mantenemos este espacio positivo para aprender y tomar descansos inteligentes."
        },
        "terms": {
            "title": "T?rminos de servicio",
            "content": "**?ltima actualizaci?n: 7 de septiembre de 2026**\n\nAl usar el servicio Procrastiq, aceptas estos t?rminos. Si no est?s de acuerdo, no utilices el servicio.\n\n## 1. Sobre Procrastiq\n\nProcrastiq es una plataforma en l?nea centrada en el aprendizaje, los cuestionarios, los rompecabezas y otro contenido interactivo.\n\nEl contenido del servicio est? destinado principalmente a la educaci?n y al entretenimiento. No constituye asesoramiento profesional, jur?dico, m?dico, financiero ni de otro tipo especializado.\n\n## 2. Cuenta de usuario\n\nAlgunas funciones de Procrastiq pueden requerir crear una cuenta de usuario.\n\nEres responsable de la exactitud de la informaci?n de tu cuenta y de proteger tus credenciales de acceso.\n\nUna cuenta no debe usarse para vulnerar los derechos de terceros, la ley aplicable ni estos t?rminos.\n\n## 3. Normas de uso\n\nAl usar Procrastiq no est? permitido, en particular:\n\n* publicar contenido ilegal, fraudulento, de odio u otro contenido da?ino,\n* vulnerar derechos de autor u otros derechos de terceros,\n* acosar a otros usuarios,\n* intentar alterar la seguridad o el funcionamiento del servicio,\n* extraer contenido o datos de forma automatizada de maneras que no permitimos,\n* abusar de valoraciones, XP, clasificaciones u otros mecanismos de juego.\n\n## 4. Contenido del usuario\n\nLos usuarios pueden crear o enviar su propio contenido, como cuestionarios, preguntas, comentarios u otras aportaciones.\n\nAl enviar contenido, confirmas que tienes derecho a publicarlo.\n\nConservas tus derechos sobre tu contenido. Al mismo tiempo, nos concedes un derecho no exclusivo a almacenarlo, mostrarlo, adaptarlo t?cnicamente y ponerlo a disposici?n dentro de Procrastiq en la medida necesaria para operar el servicio.\n\n## 5. Moderaci?n de contenido\n\nPodemos revisar el contenido de los usuarios y, si se vulneran estos t?rminos o la ley aplicable, rechazarlo, ocultarlo o eliminarlo.\n\nEn casos graves o reiterados, podemos restringir o cancelar una cuenta de usuario.\n\nCuando las circunstancias lo permitan y la ley lo exija, informaremos al usuario del motivo de esa decisi?n.\n\n## 6. Contenido de Procrastiq\n\nEl contenido publicado directamente por Procrastiq puede contener errores o inexactitudes. Aunque intentamos comprobar y mejorar la informaci?n de forma continua, no podemos garantizar su integridad ni la ausencia de errores.\n\nLos cuestionarios y otro contenido educativo tienen principalmente car?cter informativo y recreativo.\n\n## 7. Disponibilidad del servicio\n\nNos esforzamos por mantener Procrastiq disponible y operativo, pero no podemos garantizar un funcionamiento ininterrumpido o sin errores.\n\nPodemos cambiar, ampliar o interrumpir partes del servicio con el tiempo.\n\n## 8. Responsabilidad\n\nEn la medida permitida por la ley aplicable, no somos responsables de los da?os derivados del uso indebido del servicio o de la confianza en contenido de car?cter meramente informativo o educativo.\n\nEsto no afecta a los derechos de los usuarios que no puedan limitarse conforme a la ley aplicable.\n\n## 9. Privacidad\n\nLa informaci?n sobre c?mo tratamos los datos personales est? disponible en nuestra [Pol?tica de privacidad](/legal/privacy).\n\n## 10. Cambios en estos t?rminos\n\nPodemos actualizar estos t?rminos de vez en cuando, por ejemplo por cambios en el servicio, en la ley o en el funcionamiento de Procrastiq.\n\nLa fecha de la ?ltima actualizaci?n aparecer? siempre en la parte superior de esta p?gina. Tambi?n podemos informar a los usuarios de cambios importantes a trav?s del servicio o por correo electr?nico.\n\n## 11. Contacto\n\nSi tienes preguntas sobre estos t?rminos, puedes contactarnos en:\n\n[hello@procrastiq.com](mailto:hello@procrastiq.com)"
        },
        "privacy": {
            "title": "Pol?tica de privacidad",
            "content": "**?ltima actualizaci?n: 7 de septiembre de 2026**\n\nNos tomamos tu privacidad en serio. A continuaci?n explicamos qu? datos personales tratamos cuando usas Procrastiq, por qu? los necesitamos y qu? derechos tienes.\n\n## 1. Qui?n trata los datos\n\nEl responsable del tratamiento de los datos personales es:\n\n**Michal Orl?k**\npersona f?sica\n\nContacto para consultas sobre protecci?n de datos personales:\n\n**[hello@procrastiq.com](mailto:hello@procrastiq.com)**\n\n## 2. Qu? datos tratamos\n\nSeg?n c?mo uses Procrastiq, podemos tratar en particular:\n\n* datos de tu cuenta, por ejemplo nombre, nombre de usuario y direcci?n de correo electr?nico,\n* datos obtenidos al iniciar sesi?n mediante un servicio externo, por ejemplo Google,\n* informaci?n sobre el uso del servicio, por ejemplo contenido visto, resultados de cuestionarios, XP obtenidos, rachas, reacciones, marcadores y actividad en el feed,\n* contenido que crees o env?es t? mismo,\n* datos t?cnicos, por ejemplo direcci?n IP, tipo de dispositivo, navegador e informaci?n necesaria para la seguridad y el correcto funcionamiento del servicio.\n\n## 3. Por qu? usamos los datos\n\nUsamos los datos personales principalmente para:\n\n* crear y gestionar tu cuenta,\n* proporcionar las funciones de Procrastiq,\n* guardar tu progreso, resultados, XP y otra actividad,\n* personalizar el contenido y las recomendaciones,\n* proteger el servicio frente a usos indebidos,\n* resolver errores y problemas t?cnicos,\n* comunicarnos contigo,\n* analizar y mejorar el funcionamiento del servicio.\n\n## 4. Base jur?dica del tratamiento\n\nTratamos los datos seg?n cada finalidad principalmente:\n\n* porque son necesarios para prestar el servicio,\n* sobre la base de nuestro inter?s leg?timo en la seguridad y la mejora de Procrastiq,\n* sobre la base de tu consentimiento cuando se requiere,\n* o para cumplir obligaciones legales.\n\nSi el tratamiento se basa en el consentimiento, puedes retirarlo en cualquier momento.\n\n## 5. A qui?n pueden comunicarse los datos\n\nNo vendemos tus datos personales.\n\nPara operar el servicio, sin embargo, podemos usar proveedores externos, por ejemplo para:\n\n* alojamiento e infraestructura,\n* autenticaci?n de usuarios,\n* env?o de correos electr?nicos y notificaciones,\n* anal?tica y diagn?stico de errores.\n\nEstos proveedores solo pueden tratar los datos en la medida necesaria para prestar sus servicios.\n\n## 6. Cu?nto tiempo conservamos los datos\n\nLos datos asociados a tu cuenta se conservan generalmente mientras exista la cuenta y, despu?s, durante el tiempo necesario para cumplir obligaciones legales o proteger nuestros intereses leg?timos.\n\nLos datos t?cnicos y anal?ticos se conservan solo durante el tiempo necesario para su finalidad.\n\n## 7. Tus derechos\n\nEn relaci?n con el tratamiento de datos personales, seg?n las circunstancias tienes derecho a:\n\n* obtener informaci?n sobre qu? datos tratamos sobre ti,\n* solicitar la rectificaci?n de datos inexactos,\n* solicitar la eliminaci?n de datos,\n* solicitar la limitaci?n del tratamiento,\n* oponerte a determinadas formas de tratamiento,\n* recibir tus datos en un formato portable,\n* retirar el consentimiento otorgado.\n\nPuedes enviar una solicitud a:\n\n**[hello@procrastiq.com](mailto:hello@procrastiq.com)**\n\nRespondemos a las solicitudes de conformidad con la legislaci?n aplicable.\n\n## 8. Eliminaci?n de la cuenta\n\nSi el servicio permite eliminar la cuenta, puedes solicitar su eliminaci?n directamente en la configuraci?n de la cuenta o contactarnos en **[hello@procrastiq.com](mailto:hello@procrastiq.com)**.\n\nAl eliminar la cuenta, eliminamos o anonimizamos los datos personales que ya no necesitamos conservar por motivos legales o de seguridad.\n\n## 9. Cookies y tecnolog?as similares\n\nProcrastiq puede usar cookies y tecnolog?as similares necesarias para el inicio de sesi?n, la seguridad, el almacenamiento de ajustes y, en su caso, la anal?tica.\n\nPuede haber informaci?n m?s detallada sobre cookies en una pol?tica de cookies independiente.\n\n## 10. Seguridad\n\nUtilizamos medidas t?cnicas y organizativas adecuadas para proteger los datos personales frente al acceso no autorizado, la p?rdida o el uso indebido.\n\nSin embargo, ning?n sistema puede considerarse absolutamente seguro.\n\n## 11. Reclamaci?n\n\nSi consideras que tratamos tus datos personales en infracci?n de la legislaci?n aplicable, tambi?n puedes dirigirte a la autoridad de control competente.\n\nEn la Rep?blica Checa, esa autoridad es la **Oficina de Protecci?n de Datos Personales (??ad pro ochranu osobn?ch ?daj?)**.\n\n## 12. Cambios de esta pol?tica\n\nPodemos actualizar esta pol?tica de vez en cuando, por ejemplo en relaci?n con nuevas funciones o cambios legales.\n\nLa fecha de la ?ltima actualizaci?n siempre aparecer? en la parte superior de esta p?gina."
        },
        "progression": {
            "title": "XP, niveles y ligas",
            "content": "ProcrastiQ recompensa la curiosidad. Responde cuestionarios, crea rachas y sube de los refrigerios mentales casuales a la competencia semanal.\n\n## Puntos de experiencia (XP)\n\nGanas XP permanente cuando juegas bien, por ejemplo respuestas correctas, bonificaciones por primer intento, preguntas m?s dif?ciles, revisiones y objetivos diarios. La XP permanente nunca se reinicia y siempre cuenta para tu nivel.\n\nTambi?n hay XP clasificada usada solo para ligas semanales. La XP clasificada utiliza rendimientos decrecientes diarios: la XP ganada temprano en el d?a cuenta completamente, las ganancias posteriores cuentan menos. Esto mantiene la competencia justa si alguien juega todo el d?a.\n\n## Niveles\n\nTu nivel proviene del total de XP permanente. Cada nivel requiere un poco m?s de XP que el anterior (una curva de crecimiento), para que el progreso siga siendo significativo.\n\nTu perfil muestra cu?nta experiencia tienes en el nivel actual y cu?nta necesitas para el siguiente. \n\n## Rangos de t?tulos\n\nLos rangos son t?tulos que se desbloquean por nivel. Son una insignia de lo lejos que has llegado ? separados de los niveles semanales de la liga. \n\n- Nivel 1 ? Mente Curiosa\n- Nivel 3 ? Explorador\n- Nivel 5 ? Investigador\n- Nivel 8 ? Solucionador de problemas\n- Nivel 12 ? Analista\n- Nivel 18 ? L?gico\n- Nivel 25 ? Estratega\n- Nivel 35 ? Pol?mata\n- Nivel 50 ? Genio\n- Nivel 70 ? M?ster en Conocimiento\n- Nivel 100 ? Procrastiq Leyenda\n\n## Ligas semanales\n\nLas ligas son una competici?n semanal con otros jugadores en grupos de unos 20. \n\nNiveles de menor a alto: \n\n- Hierro\n- Bronce\n- Plata\n- Oro\n- Platino\n- Diamante\n- Maestro\n- Legendario\n\nCada semana compites con XP clasificatoria dentro de tu grupo. Al final de la semana, aproximadamente los jugadores de arriba promocionan un nivel y los de abajo descienden a otro. El resto se queda. \n\nNo debes esperar a que se reinicie el lunes para unirte. Cuando te vuelves elegible, te asignan a un grupo abierto de inmediato ? o se crea un nuevo grupo para ti. \n\nPara desbloquear ligas generalmente necesitas: \n\n- al menos 100 XP permanente\n- al menos 10 actividades completadas\n- actividad en al menos 2 d?as diferentes\n- Visibilidad en las tablas de clasificaci?n activada para tu perfil\n\nAbre la p?gina de Clasificaciones o tu panel de estad?sticas en cualquier momento para ver tu nivel, posici?n y grupo. "
        },
        "creator_progression": {
            "title": "XP de creador y rangos",
            "content": "Crear contenido en ProcrastiQ tiene su propia progresi?n ? completamente separada de la experiencia de los jugadores, los niveles y las ligas semanales. \n\nCuando la gente disfruta de tus cuestionarios y tus aperitivos mentales, ganas XP de Creador (CXP). CXP desbloquea rangos de creadores y te coloca en las tablas de clasificaci?n de Colaboradores. \n\n## Dos sistemas independientes\n\n- Progresi?n del jugador ? XP de juego, niveles, rangos de t?tulo, ligas semanales\n- Progresi?n de creadores ? CXP a partir de la contribuci?n de contenido de calidad, rangos de creadores, foros de colaboradores\n\nJugar no sube tu rango de creador. Crear no eleva tu nivel de jugador. Puedes crecer en ambos caminos a la vez. \n\n## C?mo ganas XP de creador\n\nEl CXP se concede por contribuciones aprobadas y por la implicaci?n en ese contenido, no por cu?ntos borradores env?es.\n\nRecompensas t?picas:\n\n- Contenido aprobado ? +20 CXP (una vez por ?tem)\n- Cada 10 completaciones en tu contenido ? +2 CXP\n- Cada 10 me gusta en tu contenido ? +5 CXP\n- Cada 10 marcadores en tu contenido ? +2 CXP\n\nLas vistas y otras estad?sticas se registran en tu perfil de creador, pero solo las recompensas anteriores otorgan CXP. Los valores pueden ajustarse con el tiempo.\n\n## Rangos de creadores\n\nTu rango de creador proviene del total de CXP. Los umbrales crecen aproximadamente de manera exponencial, por lo que el progreso inicial se siente r?pido y los rangos m?s altos permanecen significativos.\n\n- 0 CXP ? Colaborador\n- 50 CXP ? Creador\n- 150 CXP ? Autor\n- 400 CXP ? Experto\n- 1,000 CXP ? Mentor\n- 2,500 CXP ? Creador Maestro\n- 6,000 CXP ? Sabio Procrastiq\n\nTu perfil muestra tu rango actual, CXP y progreso hacia el siguiente rango.\n\n## Clasificaciones de colaboradores\n\nLos creadores se clasifican por XP de creador, no por n?mero de env?os.\n\n- Semanal ? CXP obtenido esta semana\n- Mensual ? CXP obtenido este mes\n- Todo el tiempo ? CXP total\n\nAbre las clasificaciones y cambia a Colaboradores para ver qui?n est? subiendo."
        }
    },
    "account": {
        "profile_picture": "Foto de perfil",
        "save_changes": "Guardar cambios",
        "update_success": "Perfil actualizado correctamente",
        "update_failed": "Error al actualizar perfil",
        "country": "Pa?s",
        "avatar": {
            "upload_label": "Subir avatar",
            "upload_success": "Avatar subido correctamente",
            "upload_failed": "Error al subir avatar",
            "delete_confirm": "?Est?s seguro de que quieres eliminar tu avatar?",
            "delete_success": "Avatar eliminado correctamente",
            "delete_failed": "Error al eliminar avatar"
        },
        "password": {
            "set_optional": "Establecer contrase?a (opcional)",
            "change_optional": "Cambiar contrase?a (opcional)",
            "oauth_info": "Iniciaste sesi?n con {{method}}. Opcionalmente, puedes establecer una contrase?a para habilitar el inicio de sesi?n por correo electr?nico/contrase?a.",
            "current": "Contrase?a actual",
            "current_placeholder": "Introduce la contrase?a actual",
            "current_required": "Se requiere la contrase?a actual para cambiar la contrase?a",
            "new": "Nueva contrase?a",
            "set_placeholder": "Establecer una contrase?a",
            "leave_blank_placeholder": "Deja en blanco para mantener la actual",
            "confirm": "Confirmar nueva contrase?a",
            "confirm_placeholder": "Confirma la nueva contrase?a",
            "mismatch": "Las nuevas contrase?as no coinciden"
        }
    },
    "play": {
        "label": "Play",
        "games": {
            "memory": "Memoria",
            "focus": "Foco",
            "sequence": "Secuencia",
            "reflex": "Reflejo"
        },
        "memory": {
            "hint_preview": "Recuerda las casillas resaltadas.",
            "hint_input": "Toca las casillas que recuerdes.",
            "cell": "Casilla {{n}}"
        },
        "focus": {
            "hint": "Encuentra el simbolo distinto."
        },
        "sequence": {
            "title": "Memoriza la secuencia",
            "countdown_hint": "Preparacion — la secuencia empieza ya.",
            "go": "Ya!",
            "hint_watch": "Mira con atencion.",
            "hint_input": "Ahora repite la secuencia."
        },
        "reflex": {
            "hint": "Elige el color, no la palabra.",
            "progress": "{{current}} / {{total}}"
        },
        "colors": {
            "red": "ROJO",
            "blue": "AZUL",
            "green": "VERDE",
            "orange": "NARANJA"
        },
        "result": {
            "success": "Bien!",
            "fail": "✗ Incorrecto."
        }
    },

    "pause": {
        "label": "Pausa",
        "types": {
            "breathing": "Respiracion",
            "eyes": "Descanso visual",
            "stretch": "Estiramiento rapido",
            "grounding": "Reset"
        },
        "skip": "Saltar",
        "continue": "Continuar",
        "breathing": {
            "inhale": "Inhala",
            "exhale": "Exhala"
        },
        "eyes": {
            "step_far": "Mira algo mas lejos de la pantalla.",
            "step_blink": "Relaja los ojos y parpadea despacio varias veces.",
            "step_close": "Cierra los ojos un momento."
        },
        "stretch": {
            "step_shoulders": "Baja los hombros y dejales relajarse.",
            "step_sit": "Sientate un poco mas erguido y relaja la espalda.",
            "step_roll": "Rueda los hombros despacio."
        },
        "grounding": {
            "prompt_color": "Encuentra 3 cosas a tu alrededor del mismo color.",
            "prompt_sounds": "Nota 2 sonidos distintos a tu alrededor.",
            "prompt_look_away": "Aparta la mirada de la pantalla unos segundos.",
            "prompt_texture": "Toca algo cercano y nota su textura.",
            "prompt_breath": "Haz una respiracion lenta y siente los pies en el suelo.",
            "prompt_feet": "Presiona suavemente los pies en el suelo y nota el contacto."
        },
        "result": {
            "done": "Listo"
        }
    },

    "content": {
        "loading": "Cargando...",
        "no_content": "A?n no hay contenido.",
        "feed_exhausted_tag": "Ya has respondido todo para esta etiqueta",
        "feed_exhausted_category": "Ya has respondido todo para esta categor?a",
        "browse_feed": "Explorar feed de contenido",
        "back_to_feed": "? Volver al feed",
        "back": "? Volver",
        "content_not_found": "Contenido no encontrado",
        "failed_load": "No se ha cargado contenido",
        "failed_load_more": "No se pudieron cargar m?s",
        "list": {
            "showing": "Mostrando {{count}} de {{total}}",
            "load_more": "Carga m?s"
        },
        "answer": {
            "your_answer": "Tu respuesta... ",
            "your_result_or_answer": "Tu resultado o respuesta... ",
            "select_or_type": "Selecciona tu respuesta... ",
            "fill_in_blank": "Rellena el espacio... ",
            "your_answer_flip": "Tu respuesta (o cambia para comprobarlo)... ",
            "reveal_answer": "Respuesta reveladora",
            "self_check_prompt": "?Lo sab?as? ",
            "knew_it": "Lo sab?a",
            "need_practice": "Necesito m?s pr?ctica",
            "check": "Comprobado",
            "completed": "Completado",
            "completing": "Guardando... ",
            "skip": "Skip",
            "next": "Siguiente",
            "checking": "Comprobando... ",
            "correct": "? ?Correcto! ",
            "not_quite": "? No exactamente. ",
            "correct_answer": "Respuesta correcta: {{answer}}"
        },
        "stats": {
            "sign_in_to_react": "Iniciar sesi?n para que te guste o no me gusta",
            "bookmark": "Marcador",
            "remove_bookmark": "Eliminar marcador",
            "save_for_later": "Salvo para m?s adelante",
            "saved": "Salvado",
            "share": "Compartir",
            "link_copied": "Enlace copiado a la carpeta",
            "share_failed": "No he podido compartir este cuestionario",
            "completions": "Completaciones: {{count}}",
            "aria_like": "Como",
            "aria_dislike": "No me gusta"
        },
        "admin": {
            "edit": "Editar",
            "delete": "Eliminar",
            "stats": "Estad?sticas",
            "stats_title": "Estad?sticas del contenido",
            "delete_confirm": "?Eliminar \"{{title}}\"?",
            "deleted": "Contenido eliminado",
            "delete_failed": "No se pudo eliminar el contenido",
            "load_failed": "No se pudo cargar el contenido",
            "id": "ID",
            "slug": "Slug",
            "status": "Estado",
            "locale": "Idioma",
            "likes": "Me gusta",
            "dislikes": "No me gusta",
            "completions": "Completados",
            "open_in_admin": "Abrir en admin"
        },
        "difficulty": {
            "label": "Dificultad: {{value}}/{{max}}",
            "value": "{{value}}/{{max}}",
            "aria": "La dificultad {{value}} fuera de {{max}}"
        },
        "detail": {
            "sign_in_to_answer": "Inicia sesi?n para responder a esta pregunta. ",
            "duration": "Duraci?n: {{minutes}} min",
            "phase": "Fase {{number}}"
        },
        "list_item": {
            "completions": "{{count}} Terminaciones",
            "completions_label": "Completaciones: {{count}}"
        },
        "feed": {
            "success": "?Correcto! ??",
            "skip": "Skip",
            "next": "Siguiente",
            "intro_gate": {
                "title": "Inicia sesión para continuar",
                "body": "Inicia sesión o crea una cuenta y Procrastiq empezará a adaptarse a lo que te gusta.",
                "body_more": "No repetirá innecesariamente las mismas preguntas, recordará tus resultados y te ofrecerá contenido según tus intereses.",
                "perks": "Además obtendrás acceso a XP, ligas, Survival, retos con otros jugadores y más funciones.",
                "register": "Crear cuenta",
                "login": "Iniciar sesión"
            }
        }
    },
    "categories": {
        "title": "Categor?as",
        "filter": "Filtrar por categor?a",
        "all": "Todos",
        "loading": "Cargando categor?as... ",
        "empty": "Sin categor?as",
        "expand": "Ampliar subcategor?as",
        "collapse": "Subcategor?as de colapso"
    },
    "tags": {
        "title": "Etiquetas",
        "all": "Todos",
        "loading": "Cargando etiquetas... ",
        "empty": "Sin etiquetas"
    },
    "bookmarks": {
        "title": "Marcadores guardados",
        "empty": "A?n no hay contenido guardado. "
    },
    "contribute": {
        "title": "Contribuir",
        "subtitle": "Env?a cuestionarios para su revisi?n. Una vez aprobados, aparecen en el feed. ",
        "subtitle_reliable": "Eres un colaborador fiable ? tus cuestionarios se publican inmediatamente. ",
        "add": "+ Enviar cuestionario",
        "add_first": "Env?a tu primer cuestionario",
        "empty": "A?n no has enviado ning?n contenido. ",
        "load_failed": "No se ha cargado tu contenido",
        "cannot_edit_approved": "El contenido aprobado solo puede ser modificado por un administrador. ",
        "delete_confirm": "?Borrar \"{{title}}\"? ",
        "deleted": "Contenido eliminado",
        "delete_failed": "No se ha eliminado contenido",
        "edit": "Editar",
        "delete": "Eliminar",
        "form": {
            "submit_title": "Enviar un cuestionario",
            "edit_title": "Editar tu cuestionario",
            "submit_button": "Enviar para revisi?n",
            "save_button": "Guardar cambios",
            "hint": "Tu cuestionario ser? revisado antes de aparecer en el feed. Los colaboradores confiables se publican inmediatamente.",
            "success_updated": "Contenido actualizado con ?xito",
            "success_published": "Contenido publicado con ?xito",
            "success_submitted": "Contenido enviado para revisi?n",
            "success_created": "Contenido creado con ?xito",
            "success_translation": "Traducci?n creada con ?xito",
            "failed": "No se pudo {{action}} el contenido",
            "action_update": "actualizar",
            "action_create": "crear",
            "choose_translation_language": "Elige un idioma para la traducci?n.",
            "admin_add": "Agregar contenido",
            "admin_edit": "Editar contenido",
            "admin_add_translation": "Agregar traducci?n",
            "admin_add_translation_lang": "Agregar traducci?n ({{lang}})",
            "admin_create": "Crear contenido",
            "admin_update": "Actualizar contenido",
            "admin_create_translation": "Crear traducci?n"
        }
    },
    "content_form": {
        "title": "T?tulo",
        "slug": "Identificador",
        "language": "Idioma",
        "difficulty": "Dificultad (1?5)",
        "country": "Pa?s",
        "status": "Estado",
        "visibility": "Visibilidad",
        "categories": "Categor?as",
        "tags": "Etiquetas",
        "translations": "Traducciones",
        "translation_new": "(nuevo)",
        "translate_hint": "Traduce la pregunta, las opciones y la explicaci?n. Los metadatos (dificultad, categor?as, etiquetas) se copian desde la fuente.",
        "choose_language": "Elegir idioma",
        "not_set": "No establecido",
        "description": "Descripci?n",
        "description_placeholder": "Descripci?n de la pregunta o tarea",
        "options": "Opciones",
        "option_n": "Opci?n {{n}}",
        "add_option": "+ Agregar opci?n",
        "remove": "Eliminar",
        "correct_answer": "Respuesta correcta",
        "explanation": "Explicaci?n",
        "explanation_placeholder": "Opcional ? se muestra despu?s de una respuesta incorrecta"
    },
    "user_stats": {
        "title": "Tus estad?sticas",
        "sign_in_prompt": "Inicia sesi?n para ver tus estad?sticas",
        "guest_title": "Clasif?cate. Sube de nivel. Sube en las ligas.",
        "guest_lead": "Sigue tu XP, desbloquea rangos de t?tulo y compite en ligas semanales una vez que inicies sesi?n.",
        "guest_perk_level": "Gana XP con cuestionarios y avanza de nivel.",
        "guest_perk_rank": "Desbloquea rangos de t?tulo a medida que aumenta tu nivel.",
        "guest_perk_league": "?nete a grupos semanales y avanza hacia Legendario.",
        "xp": "XP",
        "streak": "Racha",
        "best_streak": "Mejor racha",
        "solved": "Respondido",
        "correct": "Correcto",
        "accuracy": "Precisi?n",
        "bookmarks": "Marcadores",
        "contribute": "Contribuir",
        "likes": "Me gusta",
        "language_mastered": "Dominado",
        "language_learning": "Aprendiendo",
        "last_7_days": "?ltimos 7 d?as",
        "days_suffix": "d",
        "no_activity": "A?n no hay actividad",
        "weekly_league": "Liga semanal",
        "league_tiers": "Niveles de liga",
        "league_tiers_hint": "Niveles de menor a alto. Termina primero en tu grupo para ascender; el ?ltimo desciende. ",
        "league_position": "#{{position}} de {{total}} esta semana",
        "view_leaderboard": "Mesa completa",
        "how_leagues_work": "C?mo funciona",
        "you": "T?"
    },
    "gamification": {
        "level": "Nivel",
        "rank": "Rango",
        "streak": "Racha",
        "daily_goals": "Objetivos diarios",
        "achievements": "Logros",
        "leaderboard": "Clasificaci?n",
        "season": "Temporada",
        "xp_to_next": "{{current}} / {{next}} XP al siguiente nivel",
        "weekly": "Semanal",
        "monthly": "Este mes",
        "overall": "En general",
        "monthly_hint": "Clasifica a los jugadores por XP clasificatoria ganada durante la temporada del mes calendario actual (los mismos rendimientos decrecientes que las ligas semanales). No es un nivel de liga separado. ",
        "overall_hint": "Clasificaci?n hist?rica por XP total permanente. ",
        "overall_empty": "Todav?a no hay jugadores en el tablero general. ",
        "players": "Miembros",
        "full_board": "Mesa completa",
        "player": "Miembro",
        "ranked_xp": "XP clasificatoria",
        "total_xp": "Total XP",
        "standing": "Posici?n",
        "zone": "Posici?n",
        "zone_promotion": "Promoci?n",
        "zone_safe": "Seguro",
        "zone_relegation": "Descenso",
        "zone_legend": "Top {{promo}} promocionar ? Bottom {{releg}} descender al final del fin de semana. ",
        "unlocked": "Desbloqueado",
        "achievements_error": "No se han cargado los logros",
        "achievements_intro": "Desbloquea insignias mientras juegas ? actividad, precisi?n, rachas, dificultad y aprender de los errores. ",
        "achievement_categories": {
            "activity": "Actividad",
            "correct_answers": "Respuestas correctas",
            "learning_from_mistakes": "Aprender de los errores",
            "streaks": "Rachas",
            "difficulty": "Dificultad",
            "variety": "Variedad",
            "general": "General"
        },
        "achievement_category_hints": {
            "learning_from_mistakes": "Despu?s de una respuesta incorrecta, ese cuestionario puede volver m?s tarde para repasarlo. Responder correctamente cuenta aqu?. "
        },
        "your_rank": "Tu rango",
        "around_you": "A tu alrededor",
        "tooltip_total_xp": "{{xp}} total XP",
        "tooltip_level": "Nivel {{level}}",
        "weekly_waiting": "No se puede cargar su grupo semanal. Por favor, int?ntalo de nuevo. ",
        "weekly_ineligible": "Sigue jugando para desbloquear ligas semanales. ",
        "achievements_progress": "{{unlocked}} / {{total}} desbloqueado",
        "toast": {
            "xp_gained": "+{{xp}} XP",
            "achievement": "Logro desbloqueado: {{name}}"
        },
        "level_up": {
            "title": "?Sube de nivel! ",
            "body": "Has llegado al nivel {{level}}",
            "continue": "Sigue"
        }
    },
    "creator": {
        "rank": "Rango de creador",
        "xp": "Creator XP",
        "tooltip_rank": "{{rank}}",
        "tooltip_cxp": "{{xp}} CXP",
        "approved": "Contribuciones aprobadas",
        "views": "Opiniones",
        "completions": "Finalizaciones",
        "likes": "Me gusta",
        "bookmarks": "Marcadores",
        "top_contribution": "Contribuci?n principal",
        "newest_contribution": "Contribuci?n m?s reciente",
        "to_next": "Al siguiente rango",
        "players_board": "Miembros",
        "creators_board": "Colaboradores",
        "board_group": "Tipo de placa",
        "weekly": "Semanal",
        "monthly": "Mensual",
        "all_time": "Todos los tiempos",
        "weekly_hint": "Los creadores clasificados por XP de creador ganados esta semana. ",
        "monthly_hint": "Los creadores clasificados por XP de creador ganados este mes. ",
        "all_time_hint": "Clasificaci?n hist?rica por Creator XP. ",
        "empty": "A?n no hay creadores en la junta. "
    },
    "profile": {
        "title": "Mi perfil",
        "edit": {
            "title": "Editar perfil"
        },
        "nav": {
            "label": "Cuenta",
            "overview": "Resumen",
            "stats": "Estad?sticas",
            "leagues": "Ligas",
            "edit": "Editar perfil",
            "contribute": "Contribuir",
            "bookmarks": "Marcadores",
            "achievements": "Logros",
            "leaderboards": "Clasificaciones",
            "browse": "Explorar contenido"
        },
        "actions": {
            "back_to_home": "De vuelta a casa",
            "back_to_profile": "Volver al perfil",
            "edit": "Editar perfil",
            "contribute": "Contribuir"
        },
        "labels": {
            "initials": "Iniciales",
            "role": "Funci?n",
            "status": "Estado",
            "sign_in_method": "M?todo de inicio de sesi?n",
            "member_since": "Miembro desde",
            "country": "Pa?s",
            "reliable": "Colaborador fiable"
        },
        "sections": {
            "account_info": "Informaci?n de la cuenta",
            "authentication": "Autenticaci?n",
            "creator": "Creador",
            "stats": "Tus estad?sticas",
            "leagues": "Ligas semanales"
        },
        "stats": {
            "title": "Estad?sticas",
            "subtitle": "Tu progreso, actividad y liga semanal de un vistazo. ",
            "empty": "A?n no hay estad?sticas. Haz algunos cuestionarios para empezar. ",
            "periods": "Hoy y esta semana",
            "today": "Hoy",
            "see_all": "Todas las estad?sticas",
            "see_leagues": "P?gina de ligas abiertas"
        },
        "leagues": {
            "title": "Ligas",
            "subtitle": "Tu nivel semanal de liga, clasificaci?n de grupo y zona de ascenso o descenso. ",
            "your_group": "Tu grupo esta semana",
            "see_all": "Ligas abiertas"
        }
    },
    "notifications": {
        "title": "Notificaciones",
        "hint": "Recibe alertas sobre tu racha, posici?n en la liga y tu contenido ? incluso cuando Procrastiq est? cerrado. ",
        "enable": "Habilitar notificaciones",
        "disable": "Desactiva en este dispositivo",
        "enabled": "Notificaciones activadas",
        "disabled": "Notificaciones desactivadas en este dispositivo",
        "enable_failed": "No se pudo habilitar las notificaciones",
        "disable_failed": "No se pudo desactivar las notificaciones",
        "prefs_failed": "No se pudo guardar las preferencias",
        "unsupported": "Las notificaciones push no son compatibles con este navegador. ",
        "pref_ranking": "Liga y clasificaci?n",
        "pref_streak": "Racha",
        "pref_reactions": "Reacciones a mi contenido",
        "pref_approved": "Aprobaci?n de contenido"
    },
    "games": {
        "challenge_friend": "Challenge a friend",
        "survival_mode": "Survival",
        "challenges_inbox": "Challenges",
        "view_inbox": "View inbox",
        "pick_friend": "Pick a friend",
        "random_opponent": "Random opponent",
        "search_users": "Search by name?",
        "search_error": "Could not search users",
        "selected": "Selected",
        "selected_opponent": "Selected player",
        "pick_opponent": "Pick an opponent first",
        "random_hint": "We'll match you with an active player.",
        "any_category": "Any category",
        "category_optional": "Category (optional)",
        "start_challenge": "Send challenge",
        "challenge_created": "Challenge sent!",
        "create_error": "Could not create challenge",
        "challenge": "Challenge",
        "open": "Open",
        "new_challenge": "New challenge",
        "start_playing": "Start playing",
        "accept_play": "Accept & play",
        "decline": "Decline",
        "decline_error": "Could not decline challenge",
        "your_result": "Your result",
        "opponent_result": "Opponent",
        "waiting_opponent": "Waiting for your opponent to finish?",
        "score_line": "{{correct}}/{{total}} correct ? {{time}}",
        "you_won": "You won!",
        "you_lost": "You lost",
        "draw": "It's a draw",
        "submitting": "Submitting answers?",
        "submit_error": "Could not submit challenge",
        "load_error": "Could not load",
        "not_found": "Challenge not found",
        "no_challenges": "No challenges yet",
        "incoming": "Incoming",
        "outgoing": "Outgoing",
        "player": "Player",
        "filter": {
            "incoming": "Incoming",
            "outgoing": "Outgoing",
            "all": "All"
        },
        "status": {
            "pending": "Pending",
            "in_progress": "In progress",
            "completed": "Completed",
            "declined": "Declined",
            "expired": "Expired"
        },
        "question_progress": "Question {{current}} / {{total}}",
        "time_left": "{{seconds}}s",
        "elapsed_time": "Time {{time}}",
        "overall_time": "Total time",
        "total_time_left": "Total {{seconds}}s",
        "no_options": "No answer options for this question",
        "survival_leaderboard": "Survival leaderboard",
        "survival_leaderboard_hint": "Best survival run per player in the selected period.",
        "survival_empty": "No survival scores yet ? be the first!",
        "play_survival": "Play Survival",
        "current_score": "Score: {{score}}",
        "game_over": "Game over",
        "final_score": "You scored {{score}}",
        "personal_best": "Personal best: {{score}}",
        "daily_rank": "Daily rank: #{{rank}}",
        "weekly_rank": "Weekly rank: #{{rank}}",
        "play_again": "Play again",
        "survival_start_error": "Could not start survival run",
        "survival_error": "Survival error",
        "daily": "Daily",
        "weekly": "Weekly",
        "all_time": "All time",
        "score": "Score",
        "challenge_user": "Challenge {{name}}",
        "login_to_challenge": "Log in to challenge this player",
        "profile_error": "Could not load profile",
        "profile_not_found": "Player not found",
        "profile": "Profile",
        "notifications": "Notifications",
        "mark_all_read": "Mark all read",
        "no_notifications": "No notifications",
        "blocked_users": "Blocked players",
        "blocked_hint": "Blocked players cannot challenge you.",
        "no_blocked": "You haven't blocked anyone.",
        "unblock": "Unblock",
        "unblocked": "Player unblocked",
        "unblock_error": "Could not unblock player",
        "blocked_load_error": "Could not load blocked players",
        "survival_howto": "Responde bien el mayor tiempo posible. Tienes 20 segundos por pregunta. Se perdona un error; el segundo termina la partida. Tu puntuación es el número de aciertos.",
        "challenge_howto": "Diez preguntas, 20 segundos cada una. Ganan más aciertos y un tiempo más rápido. Verás el resultado de tu rival cuando hayáis terminado los dos.",
        "continue": "Continuar",
        "survival_reserve": "Reserva: {{count}}",
        "survival_second_chance": "¡Segunda oportunidad!",
        "guest_teaser": "Log in to challenge friends and climb Survival ranks."
    }
};
